import { SharedAngular } from '@Client/@types/sharedAngular';
import { UserConditionType } from '@Shared.Angular/@types/core/data/entities/userCondition/userConditionType';
import angular, { IController } from 'angular';

class UserConditionDialogController implements IController {
  private userCondition;
  private isAnnouncement: boolean;

  constructor(
    private $scope: angular.IScope,
    private $sce: angular.ISCEService,
    private ngDialog: SharedAngular.NgDialog
  ) {
    this.userCondition = this.$scope.ngDialogData;
    this.isAnnouncement =
      this.userCondition.conditionType === UserConditionType.Announcement;
    this.userCondition.userAcceptanceText = this.$sce.trustAsHtml(
      this.userCondition.userAcceptanceText
    );
  }

  accept = (accepted) => {
    this.ngDialog.closeAll({ accepted: accepted });
  };
}

UserConditionDialogController.$inject = ['$scope', '$sce', 'ngDialog'];

angular
  .module('flowingly.runner.user.condition')
  .controller('userConditionDialogController', UserConditionDialogController);
